module.exports = __webpack_public_path__ + "img/dot.3f81f621.svg";